import React from "react";
import { EntryComponentProps } from "@draft-js-plugins/mention/lib/MentionSuggestions/Entry/Entry";

import PersonDropdownItem from "../../dropdowns/ChoosePersonDropdown/PersonDropdownItem";

const omit = (obj: Record<string, any>, keys: string[]) => {
  return Object.entries(obj).reduce(
    (acc, [key, value]) => {
      if (!keys.includes(key)) {
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<string, any>,
  );
};

export default function CustomMentionEntry(props: EntryComponentProps) {
  const { mention, ...parentProps } = props;

  const filteredProps = omit(parentProps, [
    "selectMention",
    "searchValue",
    "isFocused",
  ]);

  return (
    <div {...filteredProps}>
      <PersonDropdownItem
        name={mention.name}
        avatarUrl={mention.avatar}
        email={mention.email}
      />
    </div>
  );
}
